<template>
    <div class="ma-2">
        <p>Hello! I'm software engineer student finishing my bachelors thesis at Jamk.</p>
        <p>I first got interested in programming after high school when I enrolled to community college. At the college I learned first touches of programming and the basics from C#, HTML, CSS and MySQL.</p>
        <p>I started applying to jobs after I graduated back in 2016. I had no luck with the job hunt as there were clear holes in my skills. So I decided to move on and got myself a job at a factory.</p>
        <p>I enrolled to Jamk university of applied sciences in 2017 with the interest of learning new things in the field. From there on I have picked new technologies and agile techniques.</p>
        <p>In software development I enjoy creating new things while solving the problems that may rise during a project.</p>
        <p>Currently I feel like I have a firm grasp of fullstack web development.</p>
        <v-divider></v-divider>
    </div>
</template>

<script>
export default {
    name: 'Introduction',
}
</script>

<style>

</style>